/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 5
// module chunks = main